const $ = require( 'jquery' );

module.exports = function() {
    return window.scrollY || document.documentElement.scrollTop || $(window).scrollTop();
};



// WEBPACK FOOTER //
// ./app/scripts/util/scroll-position.js